// ========================================
// Main App Component
// ========================================
// Root component with routing and authentication provider

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './components/Auth/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';

// Auth Components
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import PasswordReset from './components/Auth/PasswordReset';

// Main App Components
import Dashboard from './components/Dashboard/Dashboard';
import CheckinFlow from './components/FeelingsCheckin/CheckinFlow';
import CheckinHistory from './components/FeelingsCheckin/CheckinHistory';
import GratitudeList from './components/GratitudeResentment/GratitudeList';
import ResentmentList from './components/GratitudeResentment/ResentmentList';
import Settings from './components/Settings/Settings';

// Layout
import Navigation from './components/Layout/Navigation';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/password-reset" element={<PasswordReset />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Navigation />
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checkin"
            element={
              <ProtectedRoute>
                <Navigation />
                <CheckinFlow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/checkin/history"
            element={
              <ProtectedRoute>
                <Navigation />
                <CheckinHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gratitude"
            element={
              <ProtectedRoute>
                <Navigation />
                <GratitudeList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/resentments"
            element={
              <ProtectedRoute>
                <Navigation />
                <ResentmentList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Navigation />
                <Settings />
              </ProtectedRoute>
            }
          />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
